module.exports = __webpack_public_path__ + "img/9.e87644ac.jpg";